export default __webpack_public_path__ + "static/media/hht2_sitcom_02.ee906256.png";